import { render, staticRenderFns } from "./PersonHomeWorkDetail.vue?vue&type=template&id=60d1bc56&scoped=true&"
import script from "./PersonHomeWorkDetail.vue?vue&type=script&lang=js&"
export * from "./PersonHomeWorkDetail.vue?vue&type=script&lang=js&"
import style0 from "./PersonHomeWorkDetail.vue?vue&type=style&index=0&id=60d1bc56&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60d1bc56",
  null
  
)

export default component.exports